import { instance, errorService } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'
import { calculatePerimeterBuildingFootprint } from '@/services/calculate'
import { updateGridRecord, addGridRecord } from '@/services/grid'
import { validateNumber } from '@/services/config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Admin/MasterData/GridRenderer/actionRendere'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import { formatNumber } from '@/services/convert'

export default {
  props: ['dropdownData', 'groupings'],
  components: {
    'ag-grid-vue': AgGridVue,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'area') {
        const reg = /^(?!$)\d{0,9}(?:\\d{9})?$/
        if (!reg.test(value)) {
          callback(
            new Error(
              'Area should consist of 9 digits only (For e.g.:  123456789)!',
            ),
          )
        } else if (value > 9999999) {
          callback(new Error('Area should less than or equals to 9999999!'))
        } else {
          callback()
        }
      } else if (rule.field === 'value') {
        const reg = /^(?!$)\d{1,9}(?:\\d{9})?$/
        if (!reg.test(value)) {
          callback(
            new Error(
              'Quantity should consist of 4 digits only (For e.g.:  1234)!',
            ),
          )
        } else if (value > 9999) {
          callback(
            new Error('Quantity should be less than or equals to 9999!'),
          )
        } else if (value <= 0) {
          callback(
            new Error('Quantity should be greater than or equals to 1!'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'option') {
        if (String(value).length > 100) {
          callback(
            new Error('Grouping must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: true,
      list: [],
      form: {
        interiorGroupingId: undefined,
        option: null,
        value: undefined,
        area: undefined,
      },
      rules: {
        option: [
          {
            required: true,
            message: 'Please Select/Enter Grouping',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        value: [
          { required: true, message: 'Please Enter Quantity', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        area: [
          {
            required: true,
            message: 'Please Enter Area',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      width: '100%',
      height: '45em',
      visible: false,
      spinning: false,
      groupingBanks: this.dropdownData.bank_interior_grouping,
      closable: true,
      enable: true,
      selectedRows: [],
      postSort: null,
      visibleAdd: false,
      pinnedBottomRowData: null,
      recordList: [],
    }
  },
  beforeMount() {
    this.visible = true
    this.postSort = rowNodes => {
      const sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        sortedData.push(rowNodes[i].data)
      }
      this.list = [...sortedData]
    }
    this.loadingConfig()
  },
  mounted() {
    this.$root.$off('deleteInteriorGrouping')
    this.$root.$on('deleteInteriorGrouping', this.deleteBank)
    this.$root.$off('updateGrouping')
    this.$root.$on('updateGrouping', this.onUpdate)
  },
  created() {
    this.getRowStyle = params => {
      if (params.node.rowPinned) {
        return { 'font-weight': 'bold' }
      }
    }
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        rowDragManaged: true,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
        },
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        toolTipRenderer: ToolTipRenderer,
        customFilter: CustomFilter,
        textEditor: TextEditor,
        inputNumberEditor: InputNumberEditor,
        numberRender: NumberRender,
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          cellStyle: params => {
            if (params.data.display === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
        },
        {
          field: '0',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
          cellStyle: params => {
            if (params.data['0'] === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
        },
        {
          headerName: 'Grouping',
          field: 'label',
          width: 500,
          filter: 'customFilter',
          headerTooltip: 'Grouping',
          cellStyle: params => {
            if (params.data.label === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'right',
                display: 'none',
              }
            }
          },
          cellRenderer: 'toolTipRenderer',
          cellEditor: 'textEditor',
          cellRendererParams: {
            searchType: 'string',
            type: 'interiorGrouping',
          },
          editable: params => {
            if (params.data.label === 'Total') {
              return false
            } else {
              return true
            }
          },
        },
        {
          headerName: 'Quantity',
          field: 'value',
          width: 200,
          filter: 'customFilter',
          headerTooltip: 'Grouping',
          cellRenderer: 'numberRender',
          cellEditor: 'inputNumberEditor',
          cellStyle: params => {
            if (params.data.label === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'right',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'number',
            type: 'interiorGrouping',
            placeholder: 'Quantity',
            precision: 0,
            min: 1,
            max: 999999999,
          },
          editable: params => {
            if (params.data.label === 'Total') {
              return false
            } else {
              return true
            }
          },
          pinnedRowCellRenderer: () => {
            return '<strong>' + 'Total Grouping Area' + '</strong>'
          },
        },
        {
          headerName: 'Area',
          field: 'area',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Area',
          cellRenderer: 'numberRender',
          cellEditor: 'inputNumberEditor',
          cellStyle: params => {
            if (params.data.area === 'Total') {
              return { fontWeight: 'bold', textAlign: 'center' }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'number',
            type: 'interiorGrouping',
            placeholder: 'Area',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          editable: params => {
            if (params.data.label === 'Total') {
              return false
            } else {
              return true
            }
          },
          pinnedRowCellRenderer: params => {
            return '<strong>' + params.data.area + '</strong>'
          },
        },
        {
          headerName: 'Perimeter',
          field: 'perimeter',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Area',
          cellRenderer: 'numberRender',
          cellEditor: 'inputNumberEditor',
          cellStyle: params => {
            if (params.data.perimeter === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'number',
            type: 'interiorGrouping',
            placeholder: 'Perimeter',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          editable: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 60,
          suppressSizeToFit: true,
          cellStyle: params => {
            if (params.data.action === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'interiorGrouping',
            delete: true,
          },
          menuTabs: [],
          pinned: 'right',
        },
      ]
    },

    onClose() {
      this.visible = false
      this.groupingBanks = this.dropdownData.bank_interior_grouping
      this.closable = true
      this.enable = true
      this.visibleAdd = false
      this.form.interiorGroupingId = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.$emit('onClose', false)
    },

    onClear() {
      this.closable = true
      this.spinning = false
      this.enable = true
      this.groupingBanks = this.dropdownData.bank_interior_grouping
      this.form.interiorGroupingId = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    onCancel() {
      this.onClear()
      this.visibleAdd = false
    },

    onFilter(input) {
      const oldData = this.dropdownData.bank_interior_grouping
      if (input) {
        this.groupingBanks = oldData.filter(data => {
          if (data.option.toLowerCase().includes(input.toLowerCase())) {
            return data
          }
        })
      } else {
        this.groupingBanks = oldData
        this.enable = true
      }
    },

    onChange(value) {
      this.form.option = value
      const selectedData = this.dropdownData.bank_interior_grouping.find(
        i => i.option === value,
      )
      this.form.area = selectedData.area
      this.form.interiorGroupingId = selectedData.id
      this.$refs.option.onFieldBlur()
      this.$refs.area.onFieldBlur()
      this.enable = false
    },

    onLoad(params) {
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      const data = this.groupings
      const total = data.reduce((value, group) => {
        return (
          value +
          (group.value ? group.value : 0) * (group.area ? group.area : 0)
        )
      }, 0)
      this.pinnedBottomRowData = this.createData(total)
      params.api.setRowData(data)
      this.loading = false
    },

    onRowSelected() {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged() {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    deleteBank(record) {
      var that = this
      this.$confirm({
        title: `Are you sure you want to delete '${record.label}' ?`,
        content: () => (
          <div style="color:red">
            <p>
              This action will delete all information related to this tenant
              bank interior grouping.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
      })
    },

    deleteMultipleBanks() {
      var that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected interior grouping banks' ?`,
        content: () => (
          <div style="color:red">
            <p>
              This action will delete all information related to this tenant
              bank interior grouping.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
      })
    },

    confirmDelete(record) {
      this.loading = true
      this.closable = false
      const request = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.tenantBank.grouping.delete, request)
        .then(() => {
          request.forEach(element => {
            const index = this.list.findIndex(i => i.id === element)
            this.list.splice(index, 1)
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.calculateTotal(this.list)
          this.$emit('onClose', null, request, 'delete')
          this.closable = true
          this.loading = false
          this.selectedRowKeys = []
        })
        .catch(err => {
          this.loading = false
          this.closable = true
          errorService(err)
        })
    },

    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.closable = false
          this.spinning = true
          let data = [...this.list]
          const request = {
            value: _.get(this.form, 'value', 0),
            label: _.get(this.form, 'option', undefined),
            area: _.get(this.form, 'area', undefined),
          }
          if (request.area) {
            Object.assign(request, {
              perimeter: calculatePerimeterBuildingFootprint(request.area),
            })
          }
          if (this.form.interiorGroupingId) {
            Object.assign(request, {
              interiorGroupingId: this.form.interiorGroupingId,
            })
          }
          instance
            .post(
              masterAPIs.tenantBank.grouping.add(this.$route.params.id),
              request,
            )
            .then(response => {
              Object.assign(response.data.result, {
                bankInterioGroupingId: response.data.result.interiorGroupId,
              })
              data = data.concat(_.get(response.data, 'result', null))
              this.list = [...data]
              this.gridOptions.api.redrawRows()
              const itemsToAdd = addGridRecord(
                _.get(response.data, 'result', {}),
              )
              this.gridOptions.api.applyTransaction({
                add: itemsToAdd,
              })
              this.onClear()
              this.$emit('onClose', response.data.result, null, 'add')
              this.calculateTotal(this.list)
            })
            .catch(error => {
              this.closable = true
              this.spinning = false
              errorService(error)
            })
        }
      })
    },

    onUpdate(value, record, key, index) {
      const currentValue = value === 0 ? value.toString() : !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (
        currentValue !== null &&
        previousValue.toString() !== currentValue.toString()
      ) {
        let request = {}
        this.closable = false
        this.loading = true
        let isValid = true
        const groupDetails = { ...record }
        switch (key) {
          case 'value':
            isValid = validateNumber(value || 0, key, 'Quantity')
            if (isValid) {
              request = {
                value: value,
              }
            }
            break
          case 'area':
            isValid = validateNumber(value, key, 'Area')
            if (isValid) {
              request = {
                area: value,
                perimeter: calculatePerimeterBuildingFootprint(value || 0),
              }
            }
            break
          case 'perimeter':
            isValid = validateNumber(value, key, 'perimeter')
            if (isValid) {
              request = {
                perimeter: value,
              }
            }
            break
          default:
            request = {
              [key]: value,
            }
            break
        }
        if (isValid) {
          const url = masterAPIs.tenantBank.grouping.takeoff.list(
            record.id,
            this.$route.params.id,
          )
          instance
            .patch(url, request)
            .then(response => {
              const newData = [...this.list]
              newData[index] = response.data.result
              this.list = [...newData]
              this.gridOptions.api.redrawRows()
              const itemsToUpdate = updateGridRecord(
                this.gridOptions,
                record,
                newData[index],
              )
              this.gridOptions.api.applyTransaction({
                update: itemsToUpdate,
              })
              this.gridOptions.api.redrawRows()
              this.closable = true
              this.spinning = false
              this.loading = false
              if (key === 'value' || key === 'area' || key === 'perimeter') {
                this.calculateTotal(this.list)
              }
              this.$emit(
                'onClose',
                response.data.result,
                null,
                'update',
                key,
              )
            })
            .catch(err => {
              this.closable = true
              this.loading = false
              this.resetRowData(groupDetails, index)
              errorService(err)
            })
        } else {
          this.closable = true
          this.loading = false
          this.resetRowData(groupDetails, index)
        }
      }
    },

    resetRowData(groupDetails, index) {
      const newData = [...this.list]
      newData[index] = groupDetails
      this.list = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        groupDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(focusedCell.rowIndex, 'value')
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: 'value',
        })
      }
      this.$emit('onClose', groupDetails, null, 'error')
    },

    sortChanged() {
      const isSortApplied = this.gridOptions.columnApi
        .getColumnState()
        .filter(
          i => i.colId !== 'action' && i.colId !== 'display' && i.colId !== '0',
        )
        .some(element => element.sort)
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide: isSortApplied,
          },
        ],
      })
    },

    filterChanged() {
      this.calculateTotal(this.list)
    },

    onRowDragEnd(e) {
      this.loading = true
      this.closable = false
      const request = []
      this.list.forEach((i, index) => {
        request.push({
          id: i.id,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    reorder(request) {
      instance
        .patch(masterAPIs.tenantBank.grouping.reorder, request)
        .then(() => {
          this.loading = false
          this.closable = true
          this.onClear()
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
          this.$emit('onClose', this.list, null, 'sequence')
        })
        .catch(err => {
          this.loading = false
          this.closable = true
          errorService(err)
        })
    },

    calculateTotal(data) {
      const total = data.reduce((value, group) => {
        return (
          value +
          (group.value ? group.value : 0) * (group.area ? group.area : 0)
        )
      }, 0)
      this.pinnedBottomRowData = this.createData(total)
    },

    createData(area) {
      const result = []
      result.push({
        display: 'Total',
        label: 'Total',
        area: formatNumber(area),
        0: 'Total',
        value: 'Total',
        perimeter: 'Total',
        action: 'Total',
      })
      return result
    },

    updateAreaPerimeters(record, list) {
      this.recordList.add(record)
      this.calculateTotal(list)
    },
  },
}
